/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Tag, Button, Tooltip } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import ModifyBatchConfigModal from "./ModifyBatchConfigModal";
import NewBatchFormModal from "./NewBatchFormModal";
import {
  showErrorNotification,
  showNotification,
  showSuccessNotification
} from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";
import CourseFeedbackModal from "../Courses/FeedbackDetailsModal";

const BatchesDash = ({ adminConfig = {}, ROOT_URL }) => {
  const [createBatchModalOpen, setCreateBatchModalOpen] = useState(false);
  const [batchList, setBatchList] = useState([]);
  const [courseFeedbackModalOpen, setCourseFeedbackModalOpen] = useState(false);
  const [courseFeedbackDetails, setCourseFeedbackDetails] = useState({});

  const [currentBatchConfig, setCurrentBatchConfig] = useState({});
  const [currentBatchId, setCurrentBatchId] = useState();
  const [isBatchConfigUpdateModalOpen, setIsBatchConfigUpdateModalOpen] = useState(false);

  const fetchBatchesList = () => {
    axios
      .get(`${ROOT_URL}/admin/batch/list`, {})
      .then((res) => {
        const { batches } = res.data;
        setBatchList(batches);
        showSuccessNotification("Batches List Fetched Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCreateBatch = (batchDetails) => {
    axios
      .post(`${ROOT_URL}/admin/batch/create`, {
        ...batchDetails
      })
      .then(() => {
        showSuccessNotification("Batches created Successfully");
        fetchBatchesList();
        setCreateBatchModalOpen(false);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCompleteBatch = (batchId) => {
    axios
      .post(`${ROOT_URL}/admin/batch/complete`, {
        batchId
      })
      .then(() => {
        showSuccessNotification("Batch completed Successfully");
        fetchBatchesList();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchBatchCoursesFeedback = (batchId) => {
    axios
      .get(`${ROOT_URL}/admin/batch/feedback-details`, {
        params: {
          batchId
        }
      })
      .then((res) => {
        const { questionAggregate, additionalComments, feedbackCount } = res.data;
        setCourseFeedbackDetails({ additionalComments, questionAggregate, feedbackCount });
        setCourseFeedbackModalOpen(true);
        showSuccessNotification("Feedback Details Fetched successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleBatchConfigStateUpdate = (key, value) => {
    setCurrentBatchConfig({
      ...currentBatchConfig,
      [key]: value
    });
  };

  const handleUpdateBatchConfig = (updatedConfig) => {
    axios
      .post(`${ROOT_URL}/admin/batch/update-config`, {
        batchId: currentBatchId,
        updatedConfig
      })
      .then(() => {
        showSuccessNotification("Config updated successfully");
        setIsBatchConfigUpdateModalOpen(false);
        fetchBatchesList();
      })
      .catch(() => {
        showNotification("Internal Server Error", "Internal Server Error", "error");
      });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (startDate) => dayjs(startDate).format("DD MMM YYYY | hh:mm")
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (endDate) => (endDate ? dayjs(endDate).format("DD MMM YYYY | hh:mm") : "N/A")
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        const color = status === "ACTIVE" ? "green" : "geekblue";
        return (
          <Tag color={color} key={status}>
            {status.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="batch_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-around",
            gap: "8px"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              fetchBatchCoursesFeedback(row.key);
            }}
          >
            Feedback
          </Button>
          {adminConfig?.batches?.hasManageAccess && (
            <>
              <Tooltip title="Caution: This will revoke access of all users">
                <Button
                  type="primary"
                  disabled={row.status === "FINISHED"}
                  onClick={() => {
                    handleCompleteBatch(row.key);
                  }}
                >
                  Complete Batch
                </Button>
              </Tooltip>
              <Button disabled danger onClick={() => {}}>
                Delete Batch
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setCurrentBatchConfig(row.config);
                  setCurrentBatchId(row.key);
                  setIsBatchConfigUpdateModalOpen(true);
                }}
              >
                Update Config
              </Button>
            </>
          )}
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchBatchesList();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px"
        }}
      >
        <Button
          disabled={adminConfig?.admin?.hasCreateAccess}
          type="primary"
          onClick={() => {
            setCreateBatchModalOpen(true);
          }}
        >
          Create Batch
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={batchList}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <NewBatchFormModal
        isModalOpen={createBatchModalOpen}
        setIsModalOpen={setCreateBatchModalOpen}
        handleCreateBatch={handleCreateBatch}
      />
      {courseFeedbackModalOpen === true && (
        <CourseFeedbackModal
          isModalOpen={courseFeedbackModalOpen}
          setIsModalOpen={setCourseFeedbackModalOpen}
          questionsRatingObj={courseFeedbackDetails.questionAggregate}
          additionalCommentsList={courseFeedbackDetails.additionalComments}
          feedbackCount={courseFeedbackDetails.feedbackCount}
        />
      )}
      {isBatchConfigUpdateModalOpen && (
        <ModifyBatchConfigModal
          isModalOpen={isBatchConfigUpdateModalOpen}
          batchConfig={currentBatchConfig}
          setIsModalOpen={setIsBatchConfigUpdateModalOpen}
          handleBatchConfigStateUpdate={handleBatchConfigStateUpdate}
          handleUpdateBatchConfig={handleUpdateBatchConfig}
        />
      )}
    </div>
  );
};

export default BatchesDash;
